import styled from '@emotion/styled';
import { IconButton, Stack } from '@mui/material';
import { css, Grid } from '@mui/system';
import { ESizeThumbnail, ESizeThumbnailSQRT } from 'models/galery';
import { colors } from 'theme/colors';
import { EModuleType } from './helper';

interface IStyledModule {
  moduleType: EModuleType;
}

const GalleryCell = styled.div<IStyledModule>`
  ${(props: IStyledModule) =>
    props.moduleType === EModuleType.LE &&
    css`
      width: ${ESizeThumbnail.WIDTH}px;
      height: ${ESizeThumbnail.HEIGHT}px;
    `};
  ${(props: IStyledModule) =>
    (props.moduleType === EModuleType.FRT ||
      props.moduleType === EModuleType.FIREARM ||
      props.moduleType === EModuleType.ART ||
      props.moduleType === EModuleType.ANCILLARY) &&
    css`
      width: ${ESizeThumbnailSQRT.WIDTH}px;
      height: ${ESizeThumbnailSQRT.HEIGHT}px;
    `};
width: 100%;
height: 100%;
`;

const GalleryContainer = styled.div`
position: relative;
height: fit-content;
border-radius: 4px;
  &:hover {
    .zoom-icon {
    display: grid;
  }
}
`;
const ImagesGalleryContainer = styled.div<IStyledModule>`
  ${(props: IStyledModule) =>
    props.moduleType === EModuleType.LE &&
    css`
      width: ${ESizeThumbnail.WIDTH}px;
      height: ${ESizeThumbnail.HEIGHT}px;
      aspect-ratio: ${`${ESizeThumbnail.WIDTH} / ${ESizeThumbnail.HEIGHT}`};
    `};
  ${(props: IStyledModule) =>
    (props.moduleType === EModuleType.FRT ||
      props.moduleType === EModuleType.FIREARM ||
      props.moduleType === EModuleType.ART ||
      props.moduleType === EModuleType.ANCILLARY) &&
    css`
      width: ${ESizeThumbnailSQRT.WIDTH}px;
      height: ${ESizeThumbnailSQRT.HEIGHT}px;
      aspect-ratio: ${`${ESizeThumbnailSQRT.WIDTH} / ${ESizeThumbnailSQRT.HEIGHT}`};
    `};

display: flex;
flex-direction: column;
box-sizing: border-box;
cursor: pointer;
`;

const ImageContainer = styled.div`
flex: 1;
align-self: center;
min-height: 0;
align-content: center;
border-radius: 4px;
  > img {
  width: 100%;
  height: 100%;
}
`;

const ImagesGalleryControl = styled.div`
position: absolute;
bottom: 0;
left: 0;
padding: 4px;

height: 32px;
flex-shrink: 0;

display: flex;
justify-content: space-between;
align-items: center;

width: 100%;
`;

const ZoomIcon = styled.div`
position: absolute;
display: grid;
align-items: center;
justify-items: center;
top: 4px;
right: 4px;
display: none;
z-index: 9;
  button {
  width: 25px;
  height: 25px;
  padding: 0;
  background: ${colors.white};
  border: 1px solid ${colors.primary50};
  border-radius: 4px;
    & svg {
    width: 16px;
    height: 16px;
  }
    &:focus {
    background: ${colors.white};
  }
    &:active {
    background: ${colors.primary700};
      & svg {
      color: ${colors.white};
    }
  }
    &:hover {
    border: 1px solid ${colors.primary50};
    background: ${colors.primary25};
      & svg {
      color: ${colors.primary900};
    }
  }
}
`;

const MainPhotoChips = styled.div`
position: absolute;
display: grid;
align-items: center;
justify-items: center;
top: 4px;
left: 4px;
z-index: 9;
`;
const ControlButton = styled(IconButton)`
width: 24px;
height: 24px;
padding: 0;
border: 1px solid ${colors.primary50};
background: ${colors.white};
border-radius: 4px;
  &:hover {
  background: ${colors.primary25};
}
  &:disabled {
  background: ${colors.white};
}
  &:focus {
  background: ${colors.white};
}
  &:active {
  background: ${colors.primary700};
    & svg {
    color: ${colors.white};
  }
}
`;
const ControlCounter = styled('div')`
display: flex;
align-items: center;
height: 24px;
padding: 2px 4px;
border-radius: 4px;
background: #ffffffb2;
color: ${colors.primary900};
`;

const StyledPhoto = styled(Stack) <IStyledModule>`
display: flex;
align-items: center;
justify-content: center;
background: ${colors.white};
color: ${colors.primary400};
  ${(props: IStyledModule) =>
    props.moduleType === EModuleType.LE &&
    css`
      width: ${ESizeThumbnail.WIDTH}px;
      height: ${ESizeThumbnail.HEIGHT}px;
    `};
  ${(props: IStyledModule) =>
    (props.moduleType === EModuleType.FRT ||
      props.moduleType === EModuleType.FIREARM ||
      props.moduleType === EModuleType.ART ||
      props.moduleType === EModuleType.ANCILLARY) &&
    css`
      width: ${ESizeThumbnailSQRT.WIDTH}px;
      height: ${ESizeThumbnailSQRT.HEIGHT}px;
    `};
`;

const StyledEmptyPhoto = styled(Grid) <IStyledModule>`
  ${(props: IStyledModule) =>
    props.moduleType === EModuleType.LE &&
    css`
      width: ${ESizeThumbnail.WIDTH}px;
      height: ${ESizeThumbnail.HEIGHT}px;
    `};
  ${(props: IStyledModule) =>
    (props.moduleType === EModuleType.FRT ||
      props.moduleType === EModuleType.FIREARM ||
      props.moduleType === EModuleType.ART ||
      props.moduleType === EModuleType.ANCILLARY) &&
    css`
      width: ${ESizeThumbnailSQRT.WIDTH}px;
      height: ${ESizeThumbnailSQRT.HEIGHT}px;
    `};
gap: 16px;
border-radius: 4px;
border: 2px dashed ${colors.gray300};
background: ${colors.white};
display: grid;
justify-items: center;
align-content: center;
padding: 16px 30px;
`;

const IconStyled = styled('div')`
display: flex;
justify-content: center;
align-items: center;
width: 64px;
height: 64px;
border-radius: 4px;
background: ${colors.gray50};
`;

export {
  ControlButton,
  ControlCounter,
  GalleryCell,
  GalleryContainer,
  ImageContainer,
  ImagesGalleryContainer,
  ImagesGalleryControl,
  MainPhotoChips,
  ZoomIcon,
  StyledPhoto,
  StyledEmptyPhoto,
  IconStyled,
};
